export default __webpack_public_path__ + "../img/d12244589a78ff7a6b84a9066bc6c573.png";